import axios from 'axios'
import { api } from '../api'

/**
 * Constants
 * */
export const moduleName = 'auth'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const CLOSE = '_CLOSE'

export const SIGN_UP = `${moduleName}/SIGN_UP`
export const SIGN_IN = `${moduleName}/SIGN_IN`
export const VERIFY = `${moduleName}/VERIFY`
export const CONFIRM = `${moduleName}/CONFIRM`
export const SIGN_OUT = `${moduleName}/SIGN_OUT`
export const INN_SELECTED = `${moduleName}/INN_SELECTED`
export const LEGALTYPE_CHANGE = `${moduleName}/LEGALTYPE_CHANGE`
export const CODE = `${moduleName}/CODE`

export const ERRORMSG = `${moduleName}/ERRORMSG`

export const history = {
    navigate: null,
    location: null
};
//alert('user: ' + localStorage.getItem('user'));
const user = localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : null
const token = localStorage.getItem('token') && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')) : null

/**
 * Reducer
 * */
const defaultState = {
	user: user,
	is_loggined: user ? true : false,
	loading: false,
	is_veryfied: user ? true : false,
	error: null,
	code: null,
	access: false,
	showIframe: false,
	is_registered: false,
	logout_message: false,
	isInnSelected: false,
	legaltype: false,
	token: token
}

export default (state = defaultState, action) => {
	const { type, user, token, error, code, payload } = action

	switch (type) {
		case SIGN_IN + START:
			return { 
				...state, 
				loading: true 
			}

		case SIGN_IN + SUCCESS:
			return {
				...state,
				loading: false,
				code,
				user,
				is_loggined: true
			}

		case SIGN_IN + ERROR:
			return {
				...state,
				loading: false,
				error,
				is_loggined: false
			}

		case CODE + CLOSE:
			return {
				...state,
				code:null
			}

		case VERIFY + START:
			return { 
				...state, 
				loading: true,
				error: null
			}

		case VERIFY + SUCCESS:
			return {
				...state,
				loading: false,
				is_veryfied:true,
				error,
				user,
				token
			}

		case VERIFY + ERROR:
			return {
				...state,
				loading: false,
				error,
				is_veryfied: false
			}

		case SIGN_UP + START:
			return { 
				...state, 
				loading: true 
			}

		case SIGN_UP + SUCCESS:
			return { 
				...state, 
				loading: false, 
				is_registered: true, 
				code,
				user
			}

		case SIGN_UP + ERROR:
			return {
				...state,
				loading: false,
				error,
			}

		case CONFIRM + START:
			return { 
				...state, 
				loading: true 
			}

		case CONFIRM + SUCCESS:
			return {
				...state,
				loading: false,
				is_veryfied:true,
				token
			}

		case CONFIRM + ERROR:
			return {
				...state,
				loading: false,
				error,
				is_veryfied: false
			}

		case ERRORMSG + CLOSE:
			return {
				...state,
				error: null
			}
			
		case SIGN_OUT:
			return {
				...state,
				user: null,
				is_loggined: false,
				is_veryfied: false
			}
		case INN_SELECTED:
			return {
				...state,
				isInnSelected: payload.data,
			}
		case LEGALTYPE_CHANGE:
			return {
				...state,
				legaltype: payload.data,
			}
		default:
			return state
	}
}

/**
 * Action Creators
 * */

export const signIn = (params) => async (dispatch) => {

	dispatch({ type: SIGN_IN + START })
	
	try {
		const { data } = await axios.post(api+ '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
			const user = { ...data, phone: params.phone }

			dispatch({
				type: SIGN_IN + SUCCESS,
				code: data._debug_data,
				user
			});
			history.navigate('/verify');
			
		} else if(data.error) {
			dispatch({
				type: SIGN_IN + ERROR,
				error: data.message
			});			
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: SIGN_IN + ERROR,
				error: error.response
			});
	}	
}

export const verify = (params) => async (dispatch) => {
	dispatch({ type: VERIFY + START })

	try {		
		const { data } = await axios.post(api+ '?' + new URLSearchParams(params).toString())
		//console.log(data)

		if (data.success) {
			localStorage.setItem("user", JSON.stringify(data.info));
			localStorage.setItem("token", JSON.stringify(data._debug_token));
			dispatch({
				type: VERIFY + SUCCESS,
				user: data.info,
				token: data._debug_token
			});
			history.navigate('/');
		} else if(data.error) {
			dispatch({
				type: VERIFY + ERROR,				
				error: data.message
			});
			//localStorage.removeItem("user");
            //localStorage.removeItem("token");
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: VERIFY + ERROR,
				error: error.response
			});
			//localStorage.removeItem("user");
            //localStorage.removeItem("token");
	}
}

export const signUp = (params) => async (dispatch) => {
	
	dispatch({ type: SIGN_UP + START })

	try {
		
		const { data } = await axios.post(api+ '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
			const user = { ...params }

			dispatch({
				type: SIGN_UP + SUCCESS,
				code: data._debug_data,
				user
			})
			localStorage.setItem("user", JSON.stringify(user));
			history.navigate('/verify');
		} 
		if (data.error) {
			dispatch({ 
				type: SIGN_UP + ERROR, 
				error: data.message, 
			})
		}
	} catch (error) {
		if (error.response)
			dispatch({ 
				type: SIGN_UP + ERROR,
				error: error.response 
		})
	}
}

export const confirmAgent = (params) => async (dispatch) => {
	dispatch({ type: CONFIRM + START })

	try {
		const { data } = await axios.post(api+ '?' + new URLSearchParams(params).toString())
		console.log(data)

		if (data.success) {

			dispatch({ 
				type: CONFIRM + SUCCESS,				
				token: data._debug_token
			 });
			localStorage.setItem("token", JSON.stringify(data._debug_token));
			history.navigate('/');
		} else if(data.error) {
			dispatch({
				type: CONFIRM + ERROR,
				error: data.message
			});
			//localStorage.removeItem("user");
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: CONFIRM + ERROR,
				error: error.response
			})
			//localStorage.removeItem("user");
	}
}

export const closeErrorMsg = () => dispatch => dispatch({ type: ERRORMSG + CLOSE })
export const closeCode = () => dispatch => dispatch({ type: CODE + CLOSE })

export const signOut = (params) => async (dispatch) => {
	try {
		const { data } = await axios.post(api+ '?' + new URLSearchParams(params).toString())
		console.log(data)
		
		if (data.success) {
			dispatch({ type: 'SIGN_OUT' });
			localStorage.removeItem("user");
			localStorage.removeItem("lastEvent");
            localStorage.removeItem("projects");
            localStorage.removeItem("types");
            localStorage.removeItem("managers");
            localStorage.removeItem("token");
			history.navigate('/login');
			window.location.reload()
		}
	} catch (error) {
		console.log(error)
	}
}

export const setInnSelected = (data) => ({ type: INN_SELECTED, payload: { data } })
export const changeLegalType = (data) => ({ type: LEGALTYPE_CHANGE, payload: { data } })